/**
 * @author Aydin Cinar
 */

(function(app) {
    app.videoPlayer = (function() {
        var initialized = false;

        var selectors = {
            videoPlayer     : '.main-video-player',
            videoToggle     : '.main-video-actions-toggle' ,
            videoFullpage   : '.main-video-actions-full-page',
            videoVolume     : '.main-video-actions-volume',
            video     : '.main-video'
        };

        var classes = {
            stop : 'stop',
            mute : 'mute',
            visible: 'visible'
        };


        var init = function() {
            initialized = true;

            app.$objs.videoPlayer   = $(selectors.videoPlayer);
            app.$objs.videoToggle   = $(selectors.videoToggle);
            app.$objs.videoVolume   = $(selectors.videoVolume);
            app.$objs.videoFullpage = $(selectors.videoFullpage);
            app.$objs.video         = $(selectors.video);
            bind();
        };

        var bind = function() {

            app.$objs.videoToggle.on('click' , function () {
               toggleVideo();
            });

            app.$objs.videoVolume.on('click', function () {
               toggleVolume();
            });

            app.$objs.videoFullpage.on('click', function() {
               videoFull();
            });

            $(document).on('webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange', function() {
                videoResize();
            });


        };


        var toggleVideo = function() {

            if(app.$objs.videoPlayer.get(0).paused === true){
                app.$objs.videoPlayer.get(0).play();
                app.$objs.videoToggle.addClass(classes.stop);
                app.$objs.video.removeClass(classes.visible);
           }
           else {
                app.$objs.videoPlayer.get(0).pause();
                app.$objs.videoToggle.removeClass(classes.stop);
                app.$objs.video.addClass(classes.visible);
           }
        };

        var toggleVolume = function() {


            if(app.$objs.videoPlayer.get(0).muted === false){
                app.$objs.videoPlayer.get(0).muted = true;
                app.$objs.videoVolume.addClass(classes.mute);
            }
            else {
                app.$objs.videoPlayer.get(0).muted = false;
                app.$objs.videoVolume.removeClass(classes.mute);
            }

        };

        var videoFull = function() {

            if (app.$objs.videoPlayer.get(0).requestFullscreen) {
                app.$objs.videoPlayer.get(0).requestFullscreen();
            } else if (app.$objs.videoPlayer.get(0).mozRequestFullScreen) {
                app.$objs.videoPlayer.get(0).mozRequestFullScreen(); // Firefox
            } else if (app.$objs.videoPlayer.get(0).webkitRequestFullscreen) {
                app.$objs.videoPlayer.get(0).webkitRequestFullscreen(); // Chrome and Safari
            }
        };

        var videoResize = function () {

            if(app.$objs.videoPlayer.get(0).muted === true){
                app.$objs.videoVolume.addClass(classes.mute);
            }
            else {
                app.$objs.videoVolume.removeClass(classes.mute);
            }

            if(app.$objs.videoPlayer.get(0).paused === true){
                app.$objs.videoToggle.removeClass(classes.stop);
                app.$objs.video.addClass(classes.visible);
            }
            else {
                app.$objs.videoToggle.addClass(classes.stop);
                app.$objs.video .removeClass(classes.visible);
            }

            window.location.href = '#stats';

        };


        var isInitialized = function() {
            return initialized;
        };

        return {
            init:          init,
            isInitialized: isInitialized
        };
    })();

    app.registerInit('videoPlayer');
})(engelsizyasam);